import store from "../../../store";

var soliscloud = {
  async auth(login, password, integratorId, providerId) {
    var body = {
      login,
      password,
      integratorId,
      providerId,
    };

    console.log(JSON.stringify(body));
    var url = `${process.env.VUE_APP_STRAPI_URL}/api/integration/SolisCloudIntegration`;

    console.log(JSON.stringify({ url }));
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${store?.state?.auth?.token}`,
        //  Authorization: `Bearer 0064230a23941b619924ad15a59af96fd0fee7a535c1d64a3a92d8a815c756435c3522a0b91cff4f6178ebabe986dcd7e026b41d3e23ec0c9fe23d338ac3bbe0c0064b37dc4dc8dd4c0b322e12ee6a7d3b006bb852df6a5f4590bc2f25449ad511abaa348ccf6d8c6dda6fdb06c6e74518191cbcfb9fbc36181b1a542e819ed0`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });
    //let integration = res?.integration;

    // console.log("*****************RES****************");
    // console.log(JSON.stringify(integration));

    return res;
  },
};

export default soliscloud;
